import React from 'react';

import reducer from './reducer';

const initializeFilters = (filters) => {
    let analyzedFilters = Object.keys(filters).map((key) => [key, []]);

    let initialFilters = Object.fromEntries(analyzedFilters);

    return initialFilters;
};

const useFilters = (filters, previouslySelectedFilters) => {
    const [selectedFilters, dispatch] = React.useReducer(
        reducer,
        previouslySelectedFilters ? previouslySelectedFilters : initializeFilters(filters)
    );

    const updateSelections = (newSelection, key) => {
        let newState = {};
        newState[key] = newSelection;

        dispatch({ type: 'update', newState });
    };

    const clearAllSelections = () => {
        let clearedSelectionsObject = initializeFilters(selectedFilters);

        dispatch({ type: 'update', newState: clearedSelectionsObject });
    };

    return { selectedFilters, updateSelections, clearAllSelections };
};

export default useFilters;
